import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FolderLock } from 'lucide-react';
import { CaseList, CreateCaseForm } from './case-locker/CaseList';
import { CaseDetail } from './case-locker/CaseDetail';
import { clStyles } from './case-locker/styles';

// ──────────────────────────────────────────────
// MAIN PAGE
// ──────────────────────────────────────────────
export default function CaseLockerPage() {
  const { caseId: urlCaseId } = useParams();
  const navigate = useNavigate();
  const [view, setView] = useState(urlCaseId ? 'detail' : 'list');
  const [activeCaseId, setActiveCaseId] = useState(urlCaseId || null);

  useEffect(() => {
    if (urlCaseId) { setView('detail'); setActiveCaseId(urlCaseId); }
  }, [urlCaseId]);

  function goToCase(id) {
    setActiveCaseId(id);
    setView('detail');
    navigate(`/case-locker/${id}`, { replace: true });
  }

  function goToList() {
    setView('list');
    setActiveCaseId(null);
    navigate('/case-locker', { replace: true });
  }

  return (
    <div className="cl-page" data-testid="case-locker-page">
      <div className="cl-container">
        <div className="cl-page-header">
          <div className="cl-page-icon"><FolderLock size={24} /></div>
          <div>
            <h1 className="cl-page-title" data-testid="page-title">Case Locker</h1>
            <p className="cl-page-sub">Track incidents, build evidence, connect your tools.</p>
          </div>
        </div>

        {view === 'list' && (
          <CaseList onSelect={goToCase} onCreateNew={() => setView('create')} />
        )}
        {view === 'create' && (
          <CreateCaseForm onCreated={goToCase} onCancel={goToList} />
        )}
        {view === 'detail' && activeCaseId && (
          <div>
            <button className="cl-btn-back" onClick={goToList}>All Cases</button>
            <CaseDetail caseId={activeCaseId} onBack={goToList} />
          </div>
        )}
      </div>

      <style>{clStyles}</style>
    </div>
  );
}
